import React, { Suspense, useEffect, useState } from 'react'
// if this is not first, it breaks CSS for the app
// it has all the dominant styles
import './scss/style.scss'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getTheme, userLogout } from './redux/user/userSlice'
import { rememberAuth } from './redux/user/userThunk'
import { ToastContainer, Slide } from 'react-toastify'
import { invalidateToken } from './helper/omniauthHelper'
import { getAuthObject } from './apiHelper/helper'
import TimeoutModal from './views/pages/TimeoutModal'
import { getIsAi } from './utils/sharedFeaturesFunctions'

import OAuthCallbackDetector from './components/OAuthCallbackDetector'
import DefaultLayout from './layout/DefaultLayout'
import Login from './views/pages/login/Login'

const LoginSSO = React.lazy(() => import('./views/pages/login/LoginSSO'))
const SSOCallback = React.lazy(() => import('./views/pages/login/SSOCallback'))

export default function App() {
  const dispatch = useDispatch()
  const [authObject] = useState(getAuthObject())

  const authToken = useSelector((state) => state.user.authToken)
  const theme = useSelector(getTheme)

  const logout = async () => {
    invalidateToken()
    await dispatch(userLogout())
  }

  // Please Don't Touch this useEffect its main functionality for page refresh so don't touch it please
  useEffect(() => {
    if (authObject?.authToken && !window.location.href.includes('login')) {
      dispatch(rememberAuth(authObject))
    }
  }, [dispatch, authObject])

  const useBlue = getIsAi()
  useEffect(() => {
    if (theme === 'dark') {
      document.body.className = `dark-theme ${useBlue ? 'blue' : 'purple'}`
    } else {
      document.body.className = ''
    }
  }, [theme, useBlue])

  return (
    <>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover
        theme="colored"
        transition={Slide}
        icon={false}
      />
      {authToken && <TimeoutModal onLogout={logout} />}
      <HashRouter>
        <OAuthCallbackDetector>
          <Suspense
            fallback={
              <div className="pt-3 text-center">
                <div className="sk-spinner sk-spinner-pulse"></div>
              </div>
            }
          >
            <Routes>
              <Route exact path="/login" name="Login Page" element={<Login />} />
              <Route
                exact
                path="/login-sso/:tenantKey"
                name="SSO Login Page"
                element={<LoginSSO />}
              />
              <Route exact path="/sso-callback" name="SSO Callback" element={<SSOCallback />} />
              <Route path="*" name="Home" element={<DefaultLayout />} />
            </Routes>
          </Suspense>
        </OAuthCallbackDetector>
      </HashRouter>
    </>
  )
}
